import React from "react"

import classNames from "classnames"

import "./styles/_hoverlay.scss"

interface HoverlayProps {
  isDisabled?: boolean
  className?: string
  overlay: React.ReactNode
  children: React.ReactNode | React.ReactNode[]
}

export const Hoverlay = React.memo(
  ({ isDisabled, children, overlay, className }: HoverlayProps) => (
    <div className={classNames("hoverlay-container", className)}>
      <div className="hoverlay-children">{children}</div>
      {isDisabled ? null : <div className="hoverlay-overlay">{overlay}</div>}
    </div>
  )
)
